import "./style.css";
import Modal from "react-bootstrap/Modal";
import { apiCity, apiState } from "../../../api/stateAndCity";
import { useEffect, useState } from "react";
import config from "../../../config";

function BranchViews(props) {
  const [stateValue, setStateValue] = useState([]);
  const [city, setCity] = useState([]);

  async function getStateAndCity() {
    await apiState().then((result) => setStateValue(result.data.data.list));
    await apiCity().then((result) => setCity(result?.data?.data.list));
  }

  useEffect(function () {
    getStateAndCity();
  }, []);

  console.log("props.id?.auto_approve", props.id);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "12rem", height: "4px" }} id="modalhead">
          View Branch
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <div className="row gy-3">
          <div className="col-md-6">
            <label htmlFor="buyer_contact">Branch Name</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="buyer_contact"
              value={props.id?.branch_name}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="buyer_whatsapp_no">Branch Address</label>
            <textarea
              disabled
              type="text"
              className="form-control"
              id="buyer_whatsapp_no"
              value={props.id?.branch_address}
            />
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="credit_days">State</label>
            <select
              type="text"
              className="form-control"
              id="buyer_type"
              disabled
              value={props.id?.buyer_type}
            >
              <option value="" hidden>
                N/A
              </option>
              {stateValue?.map((list) => (
                <>
                  <option value={list.state_id} selected={list.state_id === props.id?.state_id}>{list.name}</option>
                </>
              ))}
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_amt">City</label>
            <select
              type="text"
              className="form-control"
              id="buyer_type"
              disabled
              value={props.id?.buyer_type}
            >
              <option value="" hidden>
                N/A
              </option>
              {city?.map((list) => (
                <>
                  <option value={list.city_id} selected={list.city_id === props.id.city_id}>{list.city}</option>
                </>
              ))}
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_amt">Pincode</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="credit_amt"
              value={props.id?.pincode}
            />
          </div> */}
          <div className="col-md-6">
            <label htmlFor="tally_godown">Tally Godown (Challan)</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="tally_godown"
              value={props.id?.tally_godown}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="voucher_type">Voucher Type (Challan)</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="voucher_type"
              value={props.id?.voucher_type}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="sales_ledger">Sales Ledger (Challan)</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="sales_ledger"
              value={props.id?.sales_ledger}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="vat_ledger">Vat Ledger (Challan)</label>
            <input
              type="text"
              className="form-control"
              id="vat_ledger"
              value={props.id?.vat_ledger}
              disabled
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="purchase_godown"> Tally Godown (Purchase)</label>
            <input
              type="text"
              className="form-control"
              id="purchase_godown"
              value={props.id?.purchase_godown}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="purchase_voucher_type">
              {" "}
              Voucher Type (Purchase)
            </label>
            <input
              type="text"
              className="form-control"
              id="purchase_voucher_type"
              value={props.id?.purchase_voucher_type}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="purchase_ledger"> Ledger (Purchase)</label>
            <input
              type="text"
              className="form-control"
              value={props.id?.purchase_ledger}
              disabled
              id="purchase_ledger"
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="purchase_vat_ledger">Vat Ledger (Purchase)</label>
            <input
              type="text"
              className="form-control"
              value={props.id?.purchase_vat_ledger}
              disabled
              id="purchase_vat_ledger"
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_note_godown">
              {" "}
              Tally Godown (Challan Return)
            </label>
            <input
              type="text"
              className="form-control"
              id="credit_note_godown"
              value={props.id?.credit_note_godown}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_note_voucher_type">
              Voucher Type (Challan Return)
            </label>
            <input
              type="text"
              className="form-control"
              id="credit_note_voucher_type"
              value={props.id?.credit_note_voucher_type}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_note_ledger"> Ledger (Challan Return)</label>
            <input
              type="text"
              className="form-control"
              id="credit_note_ledger"
              value={props.id?.credit_note_ledger}
              disabled
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="auto_approve">Auto Approve Transictions</label>
            <select
              className="form-select"
              name="auto_approve"
              value={props.id?.auto_approve ? 1 : 0}
              disabled
            >
              <option value="" hidden>
                Select
              </option>
              <option value="1">YES</option>
              <option value="0">NO</option>
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="default_print_type">Default Print Type</label>
            <select
              className="form-select"
              name="default_print_type"
              value={props.id?.default_print_type || ""}
              disabled
            >
              <option value="" hidden>
                N/A
              </option>
              {config.challanPrintOptions.map((opt) => (
                <option key={opt.key} value={opt.key}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 mt-4">
            <button
              className="branchModalCancel"
              onClick={props.hide}
              to="/branch"
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                float: "right",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BranchViews;
